import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching');

const candidateDisplayName = (fullName?: string | null): string =>
  fullName?.trim() || t('candidate_display_name_fallback');

export default candidateDisplayName;
